module.exports = __webpack_public_path__ + "img/ModelBasics2.799ec7e5.png";